import { render, staticRenderFns } from "./MyShare.vue?vue&type=template&id=5e1da1ba&scoped=true"
import script from "./MyShare.vue?vue&type=script&lang=js"
export * from "./MyShare.vue?vue&type=script&lang=js"
import style0 from "./MyShare.vue?vue&type=style&index=0&id=5e1da1ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1da1ba",
  null
  
)

export default component.exports